import { Participant } from "@local-types/participant/tableRow";
import BaseSelect from "@components/shared/control/select/BaseSelect";

const ParticipantInput: React.FC<{
  id: string;
  value?: string | number;
  onChange: any;
  required: boolean;
  options: Participant[];
}> = ({ id, value, onChange, required, options }) => {
  const baseOptions = options.map((participant) => ({
    key: participant.id,
    value: participant.name,
  }));

  return (
    <BaseSelect
      id={id}
      value={value}
      onChange={onChange}
      required={required}
      options={[{ key: 0, value: "" }, ...baseOptions]}
    />
  );
};

export default ParticipantInput;
